export default {
  divisions: [],
  division: undefined,
};
